module.exports = __webpack_public_path__ + "img/placeholder115.f5c0caf3.svg";